export default "__VITE_ASSET__o9Zat92N__"